module.exports = __webpack_public_path__ + "media/application/images/section_images/company-7c31d00254aea4e1360ba867f7a7e51f.jpg";